import React, { useState } from "react";

function Calculator() {
  const [pnum, setPnum] = useState("");
  const buttons = {
    inputStyle: "p-4 rounded-xl bg-slate-900",
  };

  function handleChange(e) {
    setPnum(pnum + e.target.value);
  }

  function backspace() {
    try {
      setPnum(pnum.slice(0, -1)); //slice method is use for delete value
    } catch (error) {
      setPnum("");
    }
  }

  function calculate() {
    setPnum(eval(pnum)); //The eval() function evaluates JavaScript code represented as a string and returns its completion value. The source is parsed as a script.
  }

  console.log(pnum);

  return (
    <>
      <center>
        <div className="bg-slate-900 lg:max-w-md h-screen pt-24 flex flex-col justify-center space-y-4">
          <div className="bg-slate-800 text-white text-center p-4 font-bold border border-slate-700">
            React Calculator
          </div>
          <div className="p-4 space-y-8">
            <div className="h-10 bg-slate-800 text-white text-right py-10 px-5 text-2xl border-2 rounded-xl border-slate-700">
              {pnum}
            </div>

            <div className="bg-slate-800 text-white text-right p-4 text-2xl border-2 rounded-xl border-slate-700 space-y-4">
              <div className="grid grid-cols-4 gap-4">
                <input
                  type="button"
                  value="C"
                  onClick={backspace}
                  className={buttons.inputStyle}
                />
                <input
                  type="button"
                  value="%"
                  onClick={handleChange}
                  className={buttons.inputStyle}
                />
                <input
                  type="button"
                  value="/"
                  onClick={handleChange}
                  className={buttons.inputStyle}
                />
                <input
                  type="button"
                  value="*"
                  onClick={handleChange}
                  className={buttons.inputStyle}
                />

                <input
                  type="button"
                  value="7"
                  onClick={handleChange}
                  className={buttons.inputStyle}
                />
                <input
                  type="button"
                  value="8"
                  onClick={handleChange}
                  className={buttons.inputStyle}
                />
                <input
                  type="button"
                  value="9"
                  onClick={handleChange}
                  className={buttons.inputStyle}
                />
                <input
                  type="button"
                  value="-"
                  onClick={handleChange}
                  className={buttons.inputStyle}
                />

                <input
                  type="button"
                  value="4"
                  onClick={handleChange}
                  className={buttons.inputStyle}
                />
                <input
                  type="button"
                  value="5"
                  onClick={handleChange}
                  className={buttons.inputStyle}
                />
                <input
                  type="button"
                  value="6"
                  onClick={handleChange}
                  className={buttons.inputStyle}
                />
                <input
                  type="button"
                  value="+"
                  onClick={handleChange}
                  className={buttons.inputStyle}
                />
                <input
                  type="button"
                  value="1"
                  onClick={handleChange}
                  className={buttons.inputStyle}
                />
                <input
                  type="button"
                  value="2"
                  onClick={handleChange}
                  className={buttons.inputStyle}
                />
                <input
                  type="button"
                  value="3"
                  onClick={handleChange}
                  className={buttons.inputStyle}
                />
                <input
                  type="button"
                  value="."
                  onClick={handleChange}
                  className={buttons.inputStyle}
                />
                <input
                  type="button"
                  value="0"
                  onClick={handleChange}
                  className="col-span-3 p-4 rounded-xl bg-slate-900"
                />
                <input
                  type="button"
                  value="="
                  onClick={calculate}
                  className="col=span-1 p-4 rounded-xl bg-slate-900"
                />
              </div>
            </div>
          </div>
        </div>
      </center>
    </>
  );
}

export default Calculator;
